<template>
  <div class="alinc">
  </div>
</template>
 
<script>
import { defineComponent, onMounted } from 'vue';

export default defineComponent({
  emits: ['captchaCheckBack', 'resetInit'],
  setup(props, ctx) {
    onMounted(() => {
      verify();
    });
    // 发送业务请求
    function verify() {
      ctx.emit('captchaCheckBack', {
        callback: (res) =>{
          if(!res){
            ctx.emit('resetInit', 'traceless');
          }
        }
      })
    }
    return {
      verify
    }

  }
})

</script>
 
<style lang="scss" scoped>
#sc {
  width: 100%;
  display: contents;
  background: red !important;
  margin: 0;
  padding: 0;
}

.alinc :deep(.nc_1__bg) {
  background: red !important;
}

.nc-container :deep(.nc_1_wrapper) {
  width: 100%;
  height: 36px;
  line-height: 36px;

  #nc_1_n1t,
  #nc_1__bg,
  #nc_1_n1z,
  #nc_1__scale_text,
  .nc-lang-cnt {
    height: 36px;
    line-height: 36px;
  }
}
</style>
